import Vue from 'vue'
import Vuex from 'vuex'

import menu from './modules/menu'
import app from './modules/app'

import * as getters from './getters'

import Filters from './filter'

Vue.use(Vuex)

// Add custom Filters
Filters.create(Vue)


const store = new Vuex.Store({
  strict: true,  // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    menu,
    app
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js